import FollowHashtagList from "./follow-hashtag-list";

export default FollowHashtagList;